import { useParams } from 'react-router-dom'
import { useAppSelector } from '@/hooks'
import { selectUserUtility } from '@/selectors'
import { evaluatedProgramViewConfigTemplate } from '@/reducers/utilityPrograms'
import { programsNewCollection } from '@/reducers/programsNew'

export default function useProgramFromParams() {
  const { programId } = useParams<{ programId: string }>()
  const utility = useAppSelector(selectUserUtility)
  const { data: programsData, isLoading: isFetchingPrograms } =
    programsNewCollection.useFetch({
      require: Boolean(programId),
    })

  const program = programsData?.find(
    (program) => program.utility_program.id === +programId,
  )

  const isEligible = program?.device_eligibility_overview?.profile?.is_eligible

  const viewConfig = program?.view_config_json
    ? evaluatedProgramViewConfigTemplate(program.view_config_json, {
        utility_name: program.utility_program.name,
      })
    : null

  return {
    isLoading: isFetchingPrograms,
    utility,
    isEligible,
    utilityProgram: program?.utility_program ?? null,
    eligibilityOverview: program?.device_eligibility_overview,
    enrollmentOverview: program?.enrollment_overview,
    programId,
    viewConfig,
  }
}
